// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9rv89","col":"styles_col__3cl1r"};